import envParser from './envParser';

const env = envParser.parse();

export default env;
